import { LandingPage } from '../features/landing/LandingPage'

export function App() {
  return <LandingPage />
}
